export const ONGLETS = ['patrouille', 'signaler', 'lampe', 'saison', 'animer'] as const
export type Onglet = (typeof ONGLETS)[number]

const DEFAUT: Onglet = 'patrouille'

function lire(): Onglet {
  const brut = location.hash.replace(/^#\/?/, '')
  return (ONGLETS as readonly string[]).includes(brut) ? (brut as Onglet) : DEFAUT
}

let courant: Onglet = DEFAUT

export function ongletCourant(): Onglet {
  return courant
}

export function aller(onglet: Onglet): void {
  if (location.hash === `#/${onglet}`) return
  location.hash = `#/${onglet}`
}

/**
 * Branche le routeur. Le rappel est invoqué immédiatement avec l'onglet
 * courant, puis à chaque changement.
 */
export function surRoute(rappel: (onglet: Onglet) => void): void {
  const traiter = () => {
    courant = lire()
    rappel(courant)
  }
  window.addEventListener('hashchange', traiter)
  traiter()
}
